import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { formatDate, formatDateTime } from '../../functions/shared-functions';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD MMM YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD MMM YYYY',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
@Component({
  selector: 'tm-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },


  ],

})

export class DatePickerComponent implements OnInit {
  @Input() placeholder;
  @Input() type;
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() label;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() form: UntypedFormGroup;
  @Input() controlName;
  @Input() label_block;
  @Output() getValue = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Input() field;
  @Input() minValue;
  @Input() maxValue;
  @Input() time_to_be_considered;
  @Input() disabled;
  @Input() verified_status;
  @Input() notes;
  @Input() reason;
  @Input() verification_required;
  @Input() label_overflow;
  @Input() consider_time;
  @Input() onlyDateMonth = 0;
  @Input() design_pattern;
  @Input() start_view;
  @Input() startAt;
  @Input() appearance

  @ViewChild('picker') picker;

  subscription: Subscription;
  prev_value;
  date = new UntypedFormControl();

  picker_open_flag = 1;
  random_id = 'date_picker' + Math.floor((Math.random() * 10000) + 1) + Date.now();

  constructor() {

  }

  ngOnInit() {
    if (this.onlyDateMonth) {
      MY_FORMATS.display.dateInput = 'DD-MMM'
    }
    // setTimeout(() => {
    //   if (this.form.get(this.controlName).value) {
    //     this.date.setValue(new Date(this.form.get(this.controlName).value));
    //     if (this.time_to_be_considered && this.date.value) {
    //       this.form.get(this.controlName).setValue(moment.parseZone(this.date.value).format('YYYY-MM-DD'));
    //     }
    //   }

    // });
    // this.subscription = this.form.get(this.controlName).valueChanges.subscribe(res => {
    //   if (res && res != this.prev_value) {
    //     this.prev_value = res;
    //     this.date.setValue(new Date(this.form.get(this.controlName).value));
    //     if (this.time_to_be_considered && this.date.value) {
    //       this.form.get(this.controlName).setValue(moment.parseZone(this.date.value).format('YYYY-MM-DD'));
    //     }
    //     this.onChange.emit({ value: moment.parseZone(this.form.get(this.controlName).value).format('YYYY-MM-DD') });
    //   }
    //   if (!res) {
    //     this.prev_value = res;
    //     this.date.reset();
    //   }
    // })
  }
  ngOnChanges(ev) {
    if (ev && ev.minValue && ev.minValue.currentValue) {
      this.minValue = new Date(ev.minValue.currentValue)
    }
    if (ev && ev.maxValue && ev.maxValue.currentValue) {
      this.maxValue = new Date(ev.maxValue.currentValue)
    }
    if (ev && ev.value) {
      this.value = ev.value.currentValue;
      if (this.value && this.value != '') {
        this.date.patchValue(this.value);
      }
      else {
        this.date.reset();
      }
    }
    if (ev && ev.startAt) {

      this.startAt = ev.startAt.currentValue;
      console.log(this.startAt)
    }
  }

  addEvent(ev) {
    if (ev && ev.value) {
      let utc_date
      if (this.consider_time) {
        utc_date = formatDateTime(ev.value)
      }
      else {
        utc_date = formatDate(ev.value)
      }
      this.form.get(this.controlName).setValue(utc_date);

      this.getValue.emit(ev);
      this.onChange.emit({ value: utc_date });
    }

  }

  anc(evt) {
  }

  removeDate(ev) {
    ev.preventDefault();
    this.form.get(this.controlName).reset();
    if (this.consider_time) {
      this.onChange.emit({ value: formatDateTime(this.form.get(this.controlName).value) });
    }
    else {
      this.onChange.emit({ value: formatDate(this.form.get(this.controlName).value) });
    }
    this.date.reset();
  }

  openPicker(open_flag) {
    if (open_flag) {
      setTimeout(() => {
        this.picker.open();
      })
    }
  }

}


